import { useState, useEffect } from "react";
import { useSearchParams } from "@pankod/refine-react-router-v6";

export const normalizeData = (data) => {
  // following code credits goes to roelbeerens see: https://forum.strapi.io/t/discussion-regarding-the-complex-response-structure-for-rest-graphql-developer-experience/13400/9
  const isObject = (data) =>
    Object.prototype.toString.call(data) === "[object Object]";

  const flatten = (data) => {
    if (!data.attributes) return data;

    return {
      id: data.id,
      ...data.attributes,
    };
  };

  if (Array.isArray(data)) {
    return data.map((item) => normalizeData(item));
  }

  if (isObject(data)) {
    if (Array.isArray(data.data)) {
      data = [...data.data];
    } else if (isObject(data.data)) {
      data = flatten({ ...data.data });
    } else if (data.data === null) {
      data = null;
    } else {
      data = flatten(data);
    }

    for (const key in data) {
      data[key] = normalizeData(data[key]);
    }

    return data;
  }

  return data;
};

export const useParams = () => {
  let par = useSearchParams();

  const [paramsReady, setParamsReady] = useState(false);
  const [params, setParams] = useState(null);
  const [paramsCount, setParamsCount] = useState(0);

  useEffect(() => {
    if (params != null || !par[0]) return;
    par = par[0];
    setParamsReady(true);
    setParams(par);
    if (Array.from(par).length == 0) return;
    setParamsCount(Array.from(par).length);
  }, [par]);

  return [params, paramsReady, paramsCount];
};
